// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
.mains
{
    height: 100vh;
    width:100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.controls1 
{
    /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */
    width:100%;
    height:60px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap:90px
    
   
}
.form-group select
{
    border-radius: 15px;
}

.controls1 label {
    font-weight: bold;
  }

.form-groupp
{
    display: flex;
    justify-content: center;
    align-items: center;
}
.sd
{
    width:40%;
    height:400px;
}
.controls2
{
       
    width:100%;
    height:500px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    
}

  #dropdown {
        font-size: 14px; /* Change the font size */
        padding: 8px; /* Add padding to increase the size */
        border: 2px solid #B6BBC4;
      }


.sbar
{
    /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */
    height: 100vh;
    width:80px;
    display: flex;
    justify-content: center;
    padding-top: 8px;
   

}
.logo1
{
    width:80%;
    height:10%;
}
.mmain
{
    display: flex;
    width: 100%;
    height: 100vh;
    background-color: black;  
    
}

.ricon
{
    width: 30px;
    height: 30px;
}


/* CSS */
.button-28 {
  display: flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  background-color: transparent;
  border: 2px solid #B6BBC4;
  border: none;
  border-radius: 15px;
  box-sizing: border-box;
  color: #3B3B3B;
  cursor: pointer;
  font-family: Roobert,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  outline: none;
  padding: 16px 24px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 25px;
  height:7px;
  will-change: transform;

}

.button-28:disabled {
  pointer-events: none;
}

.button-28:hover {
  color: #fff;
  background-color: #9BB8CD;
    
}
    
.button-28:active {
  box-shadow: none;
  transform: translateY(0);
}

.choose
{
    width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap:10px
}

.cbtn
{
    height:40px;
    width: 40px;
    border: none;
    border-radius: 15px;
    background-color: #EEF5FF;
}
.cimgg
{
    height: 20px;
    width: 20px;
}

.cbtn:hover .cimg {
    animation: bounce 0.5s cubic-bezier(0.28, 0.84, 0.42, 1) both;
  }
.idiv
{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}
  `, "",{"version":3,"sources":["webpack://./src/components/Ascreen.css"],"names":[],"mappings":";AACA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;;AAEF;;IAEI,aAAa;IACb,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;IAEI,yEAAyE;IACzE,UAAU;IACV,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;;;AAGJ;AACA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;EACnB;;AAEF;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;IAEI,SAAS;IACT,YAAY;AAChB;AACA;;;IAGI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;;AAElC;;EAEE;QACM,eAAe,EAAE,yBAAyB;QAC1C,YAAY,EAAE,qCAAqC;QACnD,yBAAyB;MAC3B;;;AAGN;;IAEI,yEAAyE;IACzE,aAAa;IACb,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,gBAAgB;;;AAGpB;AACA;;IAEI,SAAS;IACT,UAAU;AACd;AACA;;IAEI,aAAa;IACb,WAAW;IACX,aAAa;IACb,uBAAuB;;AAE3B;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;;AAGA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,kJAAkJ;EAClJ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mDAAmD;EACnD,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,WAAW;EACX,UAAU;EACV,sBAAsB;;AAExB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;;AAE3B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;;IAEI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;;IAEI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,6DAA6D;EAC/D;AACF;;IAEI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB","sourcesContent":["\r\n* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n.mains\r\n{\r\n    height: 100vh;\r\n    width:100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.controls1 \r\n{\r\n    /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */\r\n    width:100%;\r\n    height:60px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap:90px\r\n    \r\n   \r\n}\r\n.form-group select\r\n{\r\n    border-radius: 15px;\r\n}\r\n\r\n.controls1 label {\r\n    font-weight: bold;\r\n  }\r\n\r\n.form-groupp\r\n{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.sd\r\n{\r\n    width:40%;\r\n    height:400px;\r\n}\r\n.controls2\r\n{\r\n       \r\n    width:100%;\r\n    height:500px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    \r\n}\r\n\r\n  #dropdown {\r\n        font-size: 14px; /* Change the font size */\r\n        padding: 8px; /* Add padding to increase the size */\r\n        border: 2px solid #B6BBC4;\r\n      }\r\n\r\n\r\n.sbar\r\n{\r\n    /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */\r\n    height: 100vh;\r\n    width:80px;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding-top: 8px;\r\n   \r\n\r\n}\r\n.logo1\r\n{\r\n    width:80%;\r\n    height:10%;\r\n}\r\n.mmain\r\n{\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100vh;\r\n    background-color: black;  \r\n    \r\n}\r\n\r\n.ricon\r\n{\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n\r\n/* CSS */\r\n.button-28 {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  appearance: none;\r\n  background-color: transparent;\r\n  border: 2px solid #B6BBC4;\r\n  border: none;\r\n  border-radius: 15px;\r\n  box-sizing: border-box;\r\n  color: #3B3B3B;\r\n  cursor: pointer;\r\n  font-family: Roobert,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Helvetica,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  margin: 0;\r\n  outline: none;\r\n  padding: 16px 24px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  touch-action: manipulation;\r\n  width: 25px;\r\n  height:7px;\r\n  will-change: transform;\r\n\r\n}\r\n\r\n.button-28:disabled {\r\n  pointer-events: none;\r\n}\r\n\r\n.button-28:hover {\r\n  color: #fff;\r\n  background-color: #9BB8CD;\r\n    \r\n}\r\n    \r\n.button-28:active {\r\n  box-shadow: none;\r\n  transform: translateY(0);\r\n}\r\n\r\n.choose\r\n{\r\n    width: 80px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap:10px\r\n}\r\n\r\n.cbtn\r\n{\r\n    height:40px;\r\n    width: 40px;\r\n    border: none;\r\n    border-radius: 15px;\r\n    background-color: #EEF5FF;\r\n}\r\n.cimgg\r\n{\r\n    height: 20px;\r\n    width: 20px;\r\n}\r\n\r\n.cbtn:hover .cimg {\r\n    animation: bounce 0.5s cubic-bezier(0.28, 0.84, 0.42, 1) both;\r\n  }\r\n.idiv\r\n{\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
